// /pdf/sections/infrastructure.js
import { addMetricRow, addMetricRowSM } from "../helpers";

export function renderinstitutionalCapacity(doc, data, icons, lastY) {
    let y = lastY;
    
    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("Human Resources", 14, y);
    y += 10;

    const HumanResourcesProfile = data["Human Resources"] || [];

    let ConservancyOfficials = HumanResourcesProfile.find(i => i.indicator === "Conservancy Officials")?.value || "";
    let WasteCollectors = HumanResourcesProfile.find(i => i.indicator === "Waste Collectors")?.value || "";
    let PitCleaners = HumanResourcesProfile.find(i => i.indicator === "Pit Cleaners")?.value || "";
    let RoadCollectors = HumanResourcesProfile.find(i => i.indicator === "Road Collectors")?.value || "";
    let PrivatePitCleaners = HumanResourcesProfile.find(i => i.indicator === "Private pit cleaners")?.value || "";



    const toolsMetrics = [
        { icon: icons.hrOfficials, label: "Conservancy Officials", value: ConservancyOfficials },
        { icon: icons.hrWC, label: "Waste Collectors", value: WasteCollectors },
        { icon: icons.hrPC, label: "Pit Cleaners", value: PitCleaners },
        { icon: icons.hrRC, label: "Road Collectors", value: RoadCollectors },
        { icon: icons.hrPPC, label: "Private Pit Cleaners", value: PrivatePitCleaners },
    ];
    addMetricRowSM(doc, toolsMetrics, y);
    y += 40;


    return y;
}
